import { render, staticRenderFns } from "./FaqDropdown.vue?vue&type=template&id=35d137fc&scoped=true"
import script from "./FaqDropdown.vue?vue&type=script&lang=ts"
export * from "./FaqDropdown.vue?vue&type=script&lang=ts"
import style0 from "./FaqDropdown.vue?vue&type=style&index=0&id=35d137fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d137fc",
  null
  
)

export default component.exports